import { render, staticRenderFns } from "./manufacturerslist.vue?vue&type=template&id=d9a21be6&scoped=true"
import script from "./manufacturerslist.vue?vue&type=script&lang=js"
export * from "./manufacturerslist.vue?vue&type=script&lang=js"
import style0 from "./manufacturerslist.vue?vue&type=style&index=0&id=d9a21be6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a21be6",
  null
  
)

export default component.exports